import { Avatar } from "ui/Avatar";

import { NotificationsListItem } from "../../../../notifications.types";

import styles from "./NotificationInfo.module.scss";

const NotificationInfo = ({
  image,
  title,
  description
}: NotificationsListItem) => {
  return (
    <div className={styles.notificationInfo}>
      {image && (
        <div className={styles.notificationInfo_avatarContainer}>
          <Avatar
            image={image}
            dimensions={{
              width: 60,
              height: 48,
              borderRadius: "4px"
            }}
          />
        </div>
      )}
      <div>
        <div className={styles.notificationInfo_title}>{title}</div>
        <div className={styles.notificationInfo_description}>{description}</div>
      </div>
    </div>
  );
};

export default NotificationInfo;
